<div class="flex-container gap-8" style="height: 100%">
  <vl-widget-title [text]="'stats_ligne.couts_ligne' | trans" [widget]="widget()">
    <ng-content/>
    <vl-aide-context [sections]="aideSections"/>
  </vl-widget-title>

  @if (stats() === null) {
    <vl-loader-skeleton/>
  } @else if (chartData().labels.length) {
    <div class="chart-area fade-in">
      <canvas #coutsChart></canvas>
    </div>
  } @else {
    <div class="flex-row align-center justify-center h100 on-disabled">
      {{ 'stats_ligne.aucune_donnee' | trans }}
    </div>
  }
</div>
